import { Controller } from "@hotwired/stimulus"
import { editorStore } from "../editor/store"

// Fallback for when Rosreestr is unavailable or the plot has no cadastre
// number yet. Accepts vertices in local metres as plain text:
//   0,0
//   50,0
//   50,40
//   0,40
// Lines prefixed with # are ignored; empty lines are ignored; first vertex is
// appended as the closing vertex so users don't have to repeat it.
export default class extends Controller {
  static targets = ["panel", "textarea", "error", "rectWidth", "rectHeight"]

  toggle() {
    this.panelTarget.classList.toggle("hidden")
  }

  apply(event) {
    event.preventDefault()
    this.#error("")
    const raw = this.textareaTarget.value
    const points = this.#parse(raw)
    if (points.length < 3) {
      this.#error("Нужно минимум 3 вершины")
      return
    }

    const polygonM = [...points, points[0]]
    editorStore.replacePlot({ source: "manual", polygonM })
    this.panelTarget.classList.add("hidden")
  }

  // Rectangle shortcut: user knows width × length with 90° corners, this
  // avoids the 4-click polygon workflow. Full "make polygon rectangular"
  // constraint editing is a future stage.
  applyRectangle(event) {
    event.preventDefault()
    this.#error("")
    const w = parseFloat(this.rectWidthTarget.value)
    const h = parseFloat(this.rectHeightTarget.value)
    if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
      this.#error("Укажите ширину и длину в метрах (> 0)")
      return
    }
    if (w > 10_000 || h > 10_000) {
      this.#error("Слишком большие размеры (> 10 км)")
      return
    }
    const polygonM = [[0, 0], [w, 0], [w, h], [0, h], [0, 0]]
    editorStore.replacePlot({ source: "manual", polygonM })
    this.panelTarget.classList.add("hidden")
  }

  #parse(text) {
    const points = []
    for (const line of text.split("\n")) {
      const trimmed = line.trim()
      if (!trimmed || trimmed.startsWith("#")) continue
      const match = trimmed.match(/^(-?\d+(?:\.\d+)?)\s*[,;\s]\s*(-?\d+(?:\.\d+)?)$/)
      if (!match) {
        this.#error(`Непарсится: ${trimmed}`)
        return []
      }
      points.push([parseFloat(match[1]), parseFloat(match[2])])
    }
    return points
  }

  #error(text) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = text
  }
}
